/* @flow */

const separarDddNumero = (telefone: string) => {
    const string = telefone.replace(/\D/g, '');
    if (string.length !== 11 && string.length !== 10) {
        return null;
    }

    return {
        ddd: string.substr(0, 2),
        numero: string.substr(2),
    };
};

export default separarDddNumero;
